module.exports = __webpack_public_path__ + "img/mail.f66e529b.png";